import { Store, ActionContext, ActionTree } from "vuex";
import { CallStoreState } from "./calls";
import { DownloadStatusAudio, DownloadStatusPcap } from "../../entities/call";

import {
  CallRequestInfo,
  getCallsParameterized,
} from "@/services/calls/call-service";
import { handleStoreError } from "@/lib/error";

export const actions: ActionTree<CallStoreState, {}> = {
  async getCalls(
    this: Store<{}>,
    { commit }: ActionContext<CallStoreState, {}>,
    info: CallRequestInfo
  ) {
    commit("CALLS_TOGGLE_LOADING");
    try {
      return getCallsParameterized(info)
        .then((calls) => {
          commit("SET_CALLS", calls);
          commit("CALLS_TOGGLE_LOADING");
        })
        .catch(handleStoreError(undefined, false));
    } catch (err) {
      commit("CALLS_TOGGLE_LOADING");
    }
  },
  async getCallsPagination(
    // Metodo que se usara para la paginaciones.
    this: Store<{}>,
    { commit }: ActionContext<CallStoreState, {}>,
    info: CallRequestInfo
  ) {
    try {
      return getCallsParameterized(info)
        .then((calls) => {
          commit("SET_CALLS_PAGINATION", calls);
        })
        .catch(handleStoreError(undefined, false));
    } catch (err) {
      commit("CALLS_TOGGLE_LOADING");
    }
  },
  async updateAudioDownloadStatus(
    this: Store<{}>,
    { commit }: ActionContext<CallStoreState, {}>,
    status: DownloadStatusAudio
  ) {
    commit("SET_DOWNLOAD_STATUS_AUDIO", status);
  },
  async updatePcapDownloadStatus(
    this: Store<{}>,
    { commit }: ActionContext<CallStoreState, {}>,
    status: DownloadStatusPcap
  ) {
    commit("SET_DOWNLOAD_STATUS_PCAP", status);
  },
};
